import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import StudentDetails from "./StudentDetails";
import courses from "../../AdmissionFom/courses";

const MyApplicationsForm2 = ({ student }) => {
  const navigate = useNavigate();
  const PayChalan = () => {
    if (
      student.academic_level === null ||
      student.category === null ||
      student.course_name === null ||
      student.course_year === null ||
      student.profile_photo === "0"
    ) {
      Swal.fire({
        title: "Complete your Profile",
        icon: "warning",
        showConfirmButton: true,
      });
      return;
    } else {
      navigate("/student/payment");
    }
  };

  const [paymentStatus, setpaymentStatus] = useState("");
  const [texn, settxn] = useState("");

  // useEffect(() => {
  //   if (
  //     !student ||
  //     !Array.isArray(student.transactions) ||
  //     student.transactions.length === 0
  //   ) {
  //     setpaymentStatus("Pending");
  //   } else {
  //     const str = student.transactions[student.transactions.length - 1].txnid;
  //     const newStr = str.replace("txn_", "");

  //     settxn(newStr);
  //     setpaymentStatus(
  //       student.transactions[student.transactions.length - 1].status
  //     );
  //   }
  // }, [student]);


    useEffect(() => {
        if (!student || !Array.isArray(student.transactions) || student.transactions.length === 0) {
          setpaymentStatus("Pending");
        } else {
          const filtered = student.transactions.filter(
            t => t.amount == 50 && String(t.status).toLowerCase() === "success"
          );
          setpaymentStatus(filtered.length > 0 ? filtered[filtered.length - 1] : "Pending");
        }
      }, [student]);

  const status = () => {
    switch (student.status) {
      case 1:
        return "Approved";
      case 2:
        return "Reject";
      default:
        return "Pending";
    }
  };

  return (
    <div>
      <div className="main-dashboard-card">
        <div className="main-dashboard-card-header main-dashboard-helpdesk-header">
          <div>
            <h2 className="main-dashboard-card-title">My Applications</h2>
            <p className="main-dashboard-card-subtitle">Admission Forms</p>
          </div>
          {student.is_admission_fee_payed ? (
            <a
              target="_blank"
              href={`https://gdclalitpur.ac.in/admission/payment/print/${student.admission_code}`}
              className="main-dashboard-button"
            >
              Admission Payment receipt
            </a>
          ) : (
            <button
              disabled={paymentStatus.status === "success"}
              onClick={() => PayChalan()}
              className="main-dashboard-button"
            >
              {paymentStatus.status === "success" ? status() : "Pay Chalan"}
            </button>
          )}
        </div>
        <div className="main-dashboard-card-body">
          {/* Sirf selectedCourse ka button dikhao */}

          {/* <button onClick={()=>console.log(paymentStatus)}>hello</button> */}

          {student.status == 1 &&
            courses.filter((c) => c.code == student.course_name).length > 0 && (
              <div className="main-dashboard-app-item">
                <div className="main-dashboard-app-info">
                  <div className="main-dashboard-app-details">
                    <h4 className="main-dashboard-app-name">
                      Admission form for{" "}
                      {
                        courses.filter((c) => c.code == student.course_name)[0]
                          .name
                      }
                    </h4>
                  </div>
                </div>
                {/* //,"is_admission_submitted":true,"is_admission_fee_payed":false, ,"fee_to_pay":0 */}

                {student.is_admission_submitted === false &&
                  student.is_admission_fee_payed === false && (
                    <a
                      href={`/student/admission-form/${student.course_name.toLowerCase()}/part-${
                        student.course_year
                      }`}
                      className="main-dashboard-status-badge main-dashboard-status-badge-pending"
                    >
                      Fill Form
                    </a>
                  )}

                {student.is_admission_submitted === true &&
                  student.is_admission_fee_payed === false && (
                    <button
                      onClick={() => navigate(`/student/admission/payment`)}
                      className="main-dashboard-status-badge main-dashboard-status-badge-pending"
                    >
                      Pay - ₹{student.fee_to_pay}
                    </button>
                  )}

                {student.is_admission_submitted === true &&
                  student.is_admission_fee_payed === true && (
                    <div className="Print-dash-btn">
                      <Link
                      target="_blank"
                        to={`/admission-form/print/${student.admission_code}`}
                      >
                        Print
                      </Link>
                    </div>
                  )}
              </div>
            )}
          {student.status === 0 && (
            <>
              <div className="main-dashboard-app-item">
                <h4>Wait For Verification</h4>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default MyApplicationsForm2;
